enum DwellingTypes {
  ENTIRE = 'ENTIRE',
  PARTIAL = 'PARTIAL',
  COMBINATION = 'COMBINATION',
  NONE = 'NONE',
}

export default DwellingTypes;
